import { fillGoals } from './fillGoals'

export const totalGoalsModel = { fillAll: fillGoals }
